<template>
    <div>
        <topback title="Customer Service" path="back"></topback>
        <div class="mt-6 cs-list">
            <md-cell-item :title="cs.nickname" :brief="cs.label" v-for="cs in cs_list" v-bind:key="cs.label">
                <iconimg :name="cs.type" slot="left"></iconimg>
                <md-button class="cs-btn" type="primary" size="small" slot="right"
                    @click="contact_cs(cs.url)">Go</md-button>
            </md-cell-item>
        </div>
    </div>
</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'
import { getcwcustomerservicelist } from '@/request/api'

export default {
    name: 'CsService',
    components: {
        topback,
        iconimg
    },

    data() {
        return {
            cs_list: []
        }
    },
    created() {
        getcwcustomerservicelist().then(res => {
            if (res.code === 200) {
                this.cs_list = res.data;
            }
        })
    },

    methods: {
        contact_cs(url) {
            window.location = url;
        }
    }
}

</script>
<style scoped>
.cs-btn {
    width: 1.5rem !important;
}
.cs-list >>> .md-cell-item{
    padding: 0 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/views/csservice.vue